import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../shared/reducers';
export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            // Ignore these action types (axios responses contain non-serializable data)
            ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            // Ignore these field paths in all actions
            ignoredActionPaths: ['payload.headers', 'payload.config', 'payload.request'],
            // Ignore these paths in the state
            ignoredPaths: [],
        },
    }),
    devTools: process.env.NODE_ENV !== 'production',
});
